import React from 'react';
import { s3ImageUrl } from '@/utils/config';
import {
  buildAttributionFromSearch,
  buildIosAppStoreUrl,
  buildPlayStoreUrl,
  createDownloadClickId,
  DownloadAttribution,
  trackDownloadStoreClick
} from '@/utils/appDownload';

type DownloadAppStoreButtonsProps = {
  attribution?: DownloadAttribution;
  getAttribution?: () => DownloadAttribution;
  className?: string;
  androidImgClassName?: string;
  iosImgClassName?: string;
  eventCategory?: string;
  openInNewTab?: boolean;
};

export default function DownloadAppStoreButtons({
  attribution,
  getAttribution,
  className = 'flex items-center justify-center gap-4',
  androidImgClassName = 'h-[40px] cursor-pointer',
  iosImgClassName = 'h-[40px] cursor-pointer',
  eventCategory = 'download_smart_link_click',
  openInNewTab = false
}: DownloadAppStoreButtonsProps) {
  const navigateTo = (url: string) => {
    if (openInNewTab) {
      window.open(url, '_blank');
    } else {
      window.location.href = url;
    }
  };

  const resolveAttribution = () => {
    if (getAttribution) return getAttribution();
    if (attribution) return attribution;
    return buildAttributionFromSearch('');
  };

  const handleAndroid = (e: React.MouseEvent) => {
    e.stopPropagation();
    const attr = resolveAttribution();
    trackDownloadStoreClick('android', attr, {
      event_category: eventCategory
    });
    navigateTo(buildPlayStoreUrl(attr));
  };

  const handleIos = (e: React.MouseEvent) => {
    e.stopPropagation();
    const attr = resolveAttribution();
    trackDownloadStoreClick('ios', attr, {
      event_category: eventCategory
    });
    navigateTo(buildIosAppStoreUrl());
  };

  return (
    <div className={className}>
      <img
        src={`${s3ImageUrl}google-play-button.png`}
        alt=""
        className={androidImgClassName}
        onClick={handleAndroid}
      />
      <img
        src={`${s3ImageUrl}apple-download-button.png`}
        alt=""
        className={iosImgClassName}
        onClick={handleIos}
      />
    </div>
  );
}

export function buildBannerAttribution(userId?: string): DownloadAttribution {
  return buildAttributionFromSearch('', {
    utm_source: 'download_app_banner',
    utm_medium: 'app_banner',
    utm_campaign: userId || '',
    banner_source: 'download_app_banner',
    banner_id: 'download_app_banner',
    click_id: createDownloadClickId(),
    user_id: userId || ''
  });
}
